import { SET_IS_LOADING, SET_LIST_SERVICE, SET_ORGANIZATION_TYPES } from '../constants/listService';

const initialState = {
  listService: [],
  organizationTypes: [],
  isLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LIST_SERVICE:
      return {
        ...state,
        listService: action.payload,
      };
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
